// @catalog F.030
// Helpers compartidos por ProductDetailDrawer y sus sub-componentes.
// Formatters MXN (locale es-MX), labels de mes, constantes de demanda
// y descripciones de métodos de forecast.

export const fmtCurrency = (v: number | null | undefined): string => {
  if (v == null || Number.isNaN(v)) return "—";
  return (
    "$" +
    v.toLocaleString("es-MX", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
};

export const fmtCurrencyK = (v: number | null | undefined): string => {
  if (v == null || Number.isNaN(v)) return "—";
  const n = Math.abs(v);
  if (n >= 1_000_000)
    return "$" + (v / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (n >= 10_000) return "$" + Math.round(v / 1000) + "K";
  return (
    "$" +
    Math.round(v).toLocaleString("es-MX", {
      maximumFractionDigits: 0,
    })
  );
};

export const fmtNum = (v: number | null | undefined): string => {
  if (v == null || Number.isNaN(v)) return "—";
  return Math.round(v).toLocaleString("es-MX");
};

export const fmtPct = (v: number | null | undefined, digits = 1): string => {
  if (v == null || Number.isNaN(v)) return "—";
  return v.toFixed(digits) + "%";
};

export function formatMonthLabel(key: string): string {
  const [yearStr = "", monthStr = ""] = key.split("-");
  const names = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];
  const idx = parseInt(monthStr, 10) - 1;
  return `${names[idx] ?? monthStr} ${yearStr.slice(2)}`;
}

export const DEMAND_LABELS: Record<string, string> = {
  smooth: "Suave",
  erratic: "Errática",
  intermittent: "Intermitente",
  lumpy: "Lumpy",
  no_demand: "Sin demanda",
};

export const DEMAND_LABELS_LONG: Record<string, string> = {
  smooth: "Suave (regular)",
  erratic: "Errática (alta variabilidad)",
  intermittent: "Intermitente (esporádica)",
  lumpy: "Lumpy (esporádica + variable)",
  no_demand: "Sin demanda",
};

export type ChipTone = "good" | "warn" | "neutral" | "alert";

export const DEMAND_TONE: Record<string, ChipTone> = {
  smooth: "good",
  erratic: "warn",
  intermittent: "neutral",
  lumpy: "alert",
  no_demand: "neutral",
};

export const ABC_TONE: Record<string, ChipTone> = {
  A: "good",
  B: "warn",
  C: "neutral",
};

export const FORECAST_METHOD_DESC: Record<string, string> = {
  SES: "Suavizamiento exponencial simple",
  HW: "Holt-Winters (estacional)",
  TSB: "Teunter-Syntetos-Babai (intermitente con obsolescencia)",
  CRO: "Croston (intermitente)",
  SBA: "Syntetos-Boylan (errática)",
};

export const TONE_COLOR_VAR: Record<ChipTone, string> = {
  good: "var(--pos)",
  warn: "var(--warn)",
  alert: "var(--neg)",
  neutral: "var(--ink-3)",
};

export const TONE_BG_VAR: Record<ChipTone, string> = {
  good: "var(--pos-soft)",
  warn: "var(--warn-soft)",
  alert: "var(--neg-soft)",
  neutral: "var(--bg-2)",
};
